import axios from 'axios';

const deleteDealer = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/api/dealer/${id}`)
    .then(res => res)
    .catch(err => err);
};

export default deleteDealer;
